const PaymentGateway = {
  stripe: 1,
  lemon_squeeze: 3,
  pabbly: 2,
  pay_stack: 4,
}

export default PaymentGateway
